// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"e644c5c4","453":"d1fc8a68"}[chunkId] + ".chunk.js";
};